export default __webpack_public_path__ + "static/media/Avenir-Regular.11be5560.woff";